<template>
  <div>
    <vs-popup id="popup-offing-wave-point-detail" fullscreen title="" :active.sync="popupActive">
      <vs-row v-if="isRender" vs-w="12" vs-align="flex-start" vs-type="flex" vs-justify="start">
        <vs-col vs-type="flex" vs-align="top" vs-lg="6" vs-sm="6" vs-xs="12" class="mb-5">
          <ul class="offing-wave-point-header-col-left">
            <li><img :src="pointIcon"/></li>
            <li class="offing-wave-point-name-coodinate-wrapper">
              <p class="offing-wave-point-name" v-if="!isEditPointName" @mouseenter="oMouseoverPointName(true)"
                 @mouseleave="oMouseoverPointName(false)">
                {{ offingWavePointName }}
                <vs-icon
                  v-show="showEditIcon"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="16px"
                  class="mrl-8 mr-4 cursor-pointer"
                  @click="oncClickEditPointName"
                ></vs-icon>
              </p>
              <vs-input
                id="input-offing-wave-point-name"
                v-show="isEditPointName"
                v-model="offingWavePointName"
                :danger="validateInputPointName"
                :danger-text="getInputPointNameError()"
                @focus="onFocusInputPointName()"
                @blur="onBlurInputPointName()"
                @keydown.enter="trigger"
              />
              <p class="offing-wave-point-coordinate">
                <span class="ofw-piont-lat">予測地点： 緯度: {{ offingWavePointLat }}</span>
                <span>経度: {{ offingWavePointLng }}</span>
              </p>
            </li>
          </ul>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="top" vs-lg="6" vs-sm="6" vs-xs="12"
          class="ofw-point-datetime">
          <ul class="offing-wave-point-header-col-right">
            <li>
              <p class="date-text">データ要求日時：{{ lastUpdateAt }}</p>
              <p class="date-text">予測発表日時：{{ announcementAt }}</p></li>
<!--            <li>-->
<!--              <vs-button-->
<!--                class="request-btn"-->
<!--                color="rgb(45, 156, 219)"-->
<!--                @click="requestLatestForecast"-->
<!--              >最新の予測を取得-->
<!--              </vs-button>-->
<!--            </li>-->
            <li>
              <vs-button color="rgb(45, 156, 219)" class="delete-btn" type="border" icon-pack="feather"
                         icon="icon-trash-2" @click="deleteOffingWavePoint"></vs-button>
            </li>
          </ul>
        </vs-col>
      </vs-row>
      <div>
        <chart-wind :wind-data="windData"/>
        <chart-wave :wave-data="waveData"/>
        <chart-current :current-data="currentData"/>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import moment from "moment-timezone";
import {GeoUtil} from "@/utils"

import ChartWind from "./charts/ChartWind"
import ChartWave from "./charts/ChartWave"
import ChartCurrent from "./charts/ChartCurrent"
import FireStoreService from "@/services/fireStoreService";

// Store
const {
  mapActions: mapActionsOfLiveMap,
  mapState: mapStateOfLiveMap,
  mapGetters: mapGettersOfLiveMap,
  mapMutations: mapMutationsOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  components: {
    ChartWind,
    ChartWave,
    ChartCurrent
  },
  props: {},
  data() {
    return {
      pointIcon: require("@/assets/images/weather/offing_wave_point.svg"),
      pointId: null,
      offingWavePointName: null,
      coordinate: null,
      requestTime: null,
      initialTime: null,
      windData: null,
      waveData: null,
      currentData: null,
      localData: null,
      startTime: null,
      endTime: null,
      popupActive: false,
      showEditIcon: false,
      isEditPointName: false,
      isFocusInputPointName: false,
      wind: null,
      windDirection: null,
      validateText: "",
      localOffingWavePoint: null,
    };

  },
  watch: {
    popupActive(isActive) {
      if (!isActive) {
        this.windData = null
        this.waveData = null
        this.currentData = null
      }
    },
    isFocusInputPointName(val) {
      if (!val) {
        this.isEditPointName = false
        this.showEditIcon = false
      }
    },
  },
  computed: {
    ...mapStateOfLiveMap({offingWavePoints: state => state.offingWavePoints}),
    ...mapGettersOfLiveMap(["getOffingWavePoint"]),
    isRender() {
      return this.windData !== null && this.waveData !== null && this.currentData !== null
    },
    offingWavePointCoordinate() {
      let lng = GeoUtil.toSexagesimalScale(this.coordinate[0])
      let lat = GeoUtil.toSexagesimalScale(this.coordinate[1])
      return ` 緯度:${lat} 経度:${lng}`
    },
    offingWavePointLng() {
      let lng = GeoUtil.toSexagesimalScale(this.coordinate[0])
      return `${lng}`
    },
    offingWavePointLat() {
      let lat = GeoUtil.toSexagesimalScale(this.coordinate[1])
      return `${lat}`
    },
    validateInputPointName() {
      return this._validateInputPointName()
    },
    lastUpdateAt(){
      return moment(this.requestTime, 'YYYY-MM-DD HH:mm').format("YYYY/MM/DD(dd) HH:mm")
    },
    announcementAt(){
      return moment(this.initialTime, 'YYYY-MM-DD HH:mm').format("YYYY/MM/DD(dd) HH:mm")
    }
  },
  methods: {
    ...mapActionsOfLiveMap(["getOffingWavePointInfo"]),
    ...mapMutationsOfLiveMap(["UPDATE_OFFING_WAVE_POINT", "REMOVE_OFFING_WAVE_POINT"]),
    async show(pointId) {
      this.$vs.loading()
      let offingWavePoint = this.getOffingWavePoint(pointId)
      let payload = {
        pointId:offingWavePoint.pointId,
        pointName: offingWavePoint.pointName,
        coordinate: offingWavePoint.coordinate,
        isRequestLatestForecast: true
      }
      let res = await this.getOffingWavePointInfo(payload)
      this.$vs.loading.close()
      this.setPointData(res)
    },
    onFocusInputPointName() {
      this.isFocusInputPointName = true
    },
    async onBlurInputPointName() {
      if (this._validateInputPointName()) {
        document.getElementById("input-offing-wave-point-name").focus();
        return
      }
      let point = {
        pointId: this.pointId,
        pointName: this.offingWavePointName,
        coordinate: this.coordinate,
        requestTime: this.requestTime,
        initialTime: this.initialTime,
        pointData: {
          windData: this.windData,
          waveData: this.waveData,
          currentData: this.currentData
        },
      }
      this.UPDATE_OFFING_WAVE_POINT(point)
      await FireStoreService.saveOffingWavePoints(this.offingWavePoints)
      this.isFocusInputPointName = false
    },
    oMouseoverPointName(vale) {
      this.showEditIcon = vale
    },
    oncClickEditPointName() {
      this.isEditPointName = true
      setTimeout(() => {
        document.getElementById("input-offing-wave-point-name").focus();
      }, 200);
    },
    trigger(event) {
      if (event.keyCode !== 13) return
      if (this._validateInputPointName()) {
        document.getElementById("input-offing-wave-point-name").focus();
        return
      }
      this.isEditPointName = false
    },
    _validateInputPointName() {
      return this.offingWavePointName === "" || this.offingWavePointName.length > 20
    },
    getInputPointNameError() {
      if (this.offingWavePointName === "") {
        return "ポイント名は必須です"
      }

      if (this.offingWavePointName.length > 20) {
        return "20文字以内で入力してください"
      }
    },
    setPointData(offingWavePoint) {
      this.pointId = offingWavePoint.pointId
      this.offingWavePointName = offingWavePoint.pointName
      this.coordinate = offingWavePoint.coordinate
      this.requestTime = offingWavePoint.requestTime
      this.initialTime = offingWavePoint.initialTime
      this.windData = offingWavePoint.pointData.windData
      this.waveData = offingWavePoint.pointData.waveData
      this.currentData = offingWavePoint.pointData.currentData
      this.popupActive = true
    },
    async requestLatestForecast() {
      let payload = {
        pointName: this.offingWavePointName,
        coordinate: this.coordinate,
        isRequestLatestForecast: true
      }
      let newOffingWavePoint = await this.getOffingWavePointInfo(payload)
      this.setPointData(newOffingWavePoint)
    },
    async deleteOffingWavePoint() {
      this.REMOVE_OFFING_WAVE_POINT(this.pointId)
      await FireStoreService.saveOffingWavePoints(this.offingWavePoints)
      this.popupActive = false
    }
  },
  mounted() {
    moment.locale('ja')
  },
  created() {}
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#popup-offing-wave-point-detail {
  .vs-popup {
    max-width: 343px;

    @media screen and (min-width: $max-width-iphone-8) {
      max-width: 627px;
    }

    @media screen and (min-width: $min-width-ipad-pro-11) {
      max-width: 794px;
    }

    @media screen and (min-width: $min-width-ipad-pro-12) {
      max-width: 951px;
    }
  }

  .offing-wave-point-header-col-left{
    display: grid;
    grid-template-columns: 25px 1fr;

    @media screen and (min-width: $min-width-ipad-pro-11) {
      grid-template-rows: 25px 40px;
    }
  }

  .offing-wave-point-header-col-left li {
    list-style: none;

    .offing-wave-point-name {
      font-size: 14px;
      font-weight: bold;
      color: #EB5757;
      padding-top: 5px;

      @media screen and (min-width: $min-width-ipad-pro-11) {
        padding-top: 1px;
      }
    }

    .offing-wave-point-coordinate {
      font-size: 12px;
      font-weight: normal;
      color: #333333;

      .ofw-piont-lat::after {
        content: "\A";
        white-space: pre;
        @media screen and (min-width: $max-width-ipad-pro-11) {
          content: "\00A0\00A0\00A0";
          white-space: pre;
        }
      }
    }
  }

  .offing-wave-point-name-coodinate-wrapper {
    display: grid;
    grid-template-columns: 70px 1fr;
    grid-gap: 10px;

    @media screen and (min-width: $min-width-ipad-pro-11) {
      grid-template-columns: none;
      grid-template-rows: 1fr 1fr 1fr;
      grid-gap: 3px;
    }
  }

  .ofw-point-datetime {
    @media screen and (min-width: $max-width-iphone-8) {
      justify-content: flex-end !important;
    }

    .offing-wave-point-header-col-right {
      justify-items: start;
      align-items: start;
      text-align-last: start;
    }
  }

  .offing-wave-point-header-col-right li {
    margin-top: 4px;
    margin-right: 10px;
    float: left;
    list-style: none;

    .date-text {
      font-size: 12px;
      font-weight: normal;
      color: #333333;
      text-align: right
    }

    .request-btn {
      font-size: 12px;
      font-weight: normal;
    }

    .delete-btn {
      margin-right: 0px;
    }
  }

  .offing-wave-point-detail-crosshair {
    opacity: 0.5;
  }

}

</style>
